import React from 'react';
import { Link } from 'react-router-dom';
import { format } from 'date-fns';
import { FaClock, FaEye } from 'react-icons/fa';
import StatusBadge from '../../common/StatusBadge';

const ContentList = ({ pages = [], category }) => {
  if (!pages.length) {
    return (
      <div className="text-center py-8">
        <p className="text-gray-600 dark:text-gray-400">No pages found.</p>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-6 py-8 grid grid-cols-1 lg:grid-cols-4 gap-8">
      {/* Main Content Column */}
      <div className="col-span-3 space-y-8">
        <h1 className="text-2xl font-bold text-gray-700 dark:text-gray-200 capitalize">
          {category === 'legal' ? 'Legal Documents' : 'Support Center'}
        </h1>
        {pages.map((page) => (
          <div key={page._id} className="bg-white dark:bg-gray-800 p-6 rounded-lg shadow-lg">
            {page.featureImage && (
              <img
                src={page.featureImage}
                alt={page.title}
                className="w-full h-48 object-cover rounded-t-lg mb-4"
              />
            )}
            <div className="px-6 py-4">
              <div className="flex items-center justify-between mb-2">
                <div className="flex items-center space-x-4">
                  <span className="text-sm text-gray-600 dark:text-gray-400">
                    {format(new Date(page.updatedAt || page.createdAt), 'MMM d, yyyy')}
                  </span>
                  <StatusBadge status={page.status} />
                </div>
              </div>
              <div className="mt-2">
                <Link 
                  to={`/${category}/${page.slug}`} 
                  className="text-2xl font-bold text-gray-700 dark:text-gray-200 hover:text-blue-600 dark:hover:text-blue-400 transition-colors"
                >
                  {page.title}
                </Link>
                <p className="mt-2 text-gray-600 dark:text-gray-400">{page.shortDescription}</p>
              </div>
              <div className="flex items-center justify-between mt-4">
                <div className="flex items-center space-x-4">
                  <Link 
                    to={`/${category}/${page.slug}`} 
                    className="text-blue-500 hover:text-blue-600 dark:text-blue-400 dark:hover:text-blue-300"
                  >
                    Read more
                  </Link>
                </div>
                <div className="flex items-center space-x-4">
                  <span className="flex items-center text-sm text-gray-500 dark:text-gray-400">
                    <FaEye className="mr-1" />
                    {page.views || 0} views
                  </span>
                  <span className="flex items-center text-sm text-gray-500 dark:text-gray-400">
                    <FaClock className="mr-1" />
                    Last updated: {format(new Date(page.updatedAt || page.createdAt), 'MMM d, yyyy')}
                  </span>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Sidebar Column */}
      <div className="col-span-1 space-y-6">
        <div className="p-4 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
          <h2 className="text-lg font-bold text-gray-700 dark:text-gray-200">
            {category === 'legal' ? 'About Legal Documents' : 'About Support Center'}
          </h2>
          <p className="text-gray-600 dark:text-gray-400 mt-2">
            {category === 'legal' 
              ? 'Access our legal documents and policies to understand our terms, conditions, and commitments.'
              : 'Find help and support for your questions and concerns. We\'re here to assist you.'}
          </p>
        </div>
        
        {/* Quick Links */}
        <div className="p-4 bg-white dark:bg-gray-800 rounded-lg shadow-lg">
          <h3 className="text-lg font-bold text-gray-700 dark:text-gray-200 mb-4">Quick Links</h3>
          <ul className="space-y-2">
            {pages.slice(0, 5).map((page) => (
              <li key={page._id}>
                <Link 
                  to={`/${category}/${page.slug}`}
                  className="text-gray-600 dark:text-gray-400 hover:text-blue-600 dark:hover:text-blue-400"
                >
                  {page.title}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ContentList; 